import { render, staticRenderFns } from "./PropertyDetailsPage.vue?vue&type=template&id=152c5231&scoped=true&"
import script from "./PropertyDetailsPage.vue?vue&type=script&lang=js&"
export * from "./PropertyDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./PropertyDetailsPage.vue?vue&type=style&index=0&id=152c5231&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c5231",
  null
  
)

export default component.exports